import { render } from "./Personas.vue?vue&type=template&id=80e43ca6&scoped=true"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"

import "./Personas.vue?vue&type=style&index=0&id=80e43ca6&lang=scss&scoped=true"
import "./Personas.vue?vue&type=style&index=1&id=80e43ca6&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e43ca6"]])

export default __exports__